import en from './en-US' // 英语
import cn from './zh-CN' // 中文
import tw from './zh-TW'
export default {
    'ZH': cn,
    'EN': en,
    'ZHT': tw
}